<template lang="pug">
validation-observer(ref="observer", tag="div")
  app-divider(label="Estimativa de valor").mb-30px
  el-row.labelDiv(:gutter="30")
    el-col.inputDiv(:span="8")
      app-label(label="VTN: ", :required="false")
      el-input.input(
        name="vtn"
        v-model="avaliacaoImovel.vtn",
      )
    el-col.inputDiv(:span="8")
      app-label(label="Valor de benfeitorias reprodutivas: ", :required="false")
      el-input.input(
        name="valorBenfeitoriasReprodutivas"
        v-model="avaliacaoImovel.valorBenfeitoriasReprodutivas",
      )
    el-col.inputDiv(:span="8")
      app-label(label="Valor de benfeitorias não reprodutivas: ", :required="false")
      el-input.input(
        name="valorBenfeitoriasNaoReprodutivas"
        v-model="avaliacaoImovel.valorBenfeitoriasNaoReprodutivas",
      )
  app-divider(label="Laudos").mb-30px
  el-row.labelDiv.mt-10px(:gutter="30")
    el-col.inputDiv(:span="8")
      app-label(label="Intimação dos valores: ", :required="false")
      el-input.input(
        name="intimacaoValores"
        v-model="avaliacaoImovel.intimacaoValores",
      )
    el-col.inputDiv(:span="8")
      app-label(label="Contrapropostas: ", :required="false")
      el-input.input(
        name="contraPropostas"
        v-model="avaliacaoImovel.contraPropostas",
      )
    el-col.inputDiv(:span="8")
      app-label(label="CAU ART: ", :required="false")
      el-input.input(
        name="cauArt"
        v-model="avaliacaoImovel.cauArt",
      )
  el-row.mt-10px
    app-documentos(
      idUploadDocumento="docsLaudo"
      :maxSize='25',
      :valid-extensions="['doc', 'docx', 'jpeg', 'jpg', 'pdf', 'png']",
      :documentos="avaliacaoImovel.documentosLaudo"
      :tiposDocumentos="documentosLaudo"
      :tiposDocumentosObrigatorios="documentosObrigatoriosLaudo"
      :observer="this.$refs.observer",
      :showDivider="false"
      aba="Avaliação Imóvel Laudo"
    )
  app-divider(label="Responsável Técnico").mb-30px
  el-row.labelDiv.mt-10px(:gutter="30")
    el-col.inputDiv(:span="12")
      validation-provider(rules="required", v-slot="{ errors }", :name="nomeAba + '/Responsavel Técnico/Nome'")
        app-label(label="Nome:", :required="true")
        el-input.input(
          name="nome"
          v-model="georreferenciamento.responsavel.nome",
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
    el-col.inputDiv(:span="12")
      validation-provider(rules="required", v-slot="{ errors }", :name="nomeAba + '/Responsavel Técnico/Matrícula'")
        app-label(label="Matrícula:", :required="true")
        el-input.input(
          name="matricula"
          v-model="georreferenciamento.responsavel.matricula",
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
  el-row.mt-10px
    app-documentos(
      idUploadDocumento="docsResponsavelTecnico"
      :maxSize='25',
      :valid-extensions="['doc', 'docx', 'jpeg', 'jpg', 'pdf', 'png']",
      :documentos="georreferenciamento.documentos"
      :tiposDocumentos="documentosResponsavelTecnico"
      :tiposDocumentosObrigatorios="documentosObrigatoriosResponsavelTecnico"
      :observer="this.$refs.observer",
      :showDivider="false"
      aba="Avaliação Imóvel Responsável Técnico"
    )
</template>

<script>
import { mapActions } from 'vuex'
import AppLabel from '@/components/AppLabel.vue'
import AppDocumentos from '@/screens/central/components/cadastro/AppDocumentos'
import AppDivider from '@/components/AppDivider.vue'

export default {
  components: {
    AppDocumentos,
    AppLabel,
    AppDivider
  },

  props: {
    jsonCadastro: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      nomeAba: 'Avaliacão Imóvel',
      documentosLaudo: [],
      documentosObrigatoriosLaudo: [],
      documentosResponsavelTecnico: [],
      documentosObrigatoriosResponsavelTecnico: []
    }
  },

  async created () {
    this.documentosLaudo = await this.findDocumentos('avaliacaoImovelCadastroRf/laudos')
    this.documentosResponsavelTecnico = await this.findDocumentos('avaliacaoImovelCadastroRf/responsavelTecnico')
  },

  methods: {
    ...mapActions({
      findDocumentos: 'tipoDocumento/findTiposDocumento'
    }),

    async validate () {
      return this.$refs.observer.validate()
    }
  },

  computed: {
    avaliacaoImovel () {
      return this.jsonCadastro.avaliacaoImovel
    },
    georreferenciamento () {
      return this.jsonCadastro.georreferenciamento
    }
  }

}
</script>

<style lang="scss" scoped>
@media (max-width: 780px) {
  .labelDiv {
    display: flex;
    flex-direction: column;
  }
  .inputDiv {
    width: 100%;
  }
}
.mt-10px {
  margin-top: 10px;
}

.input {
  width: 100%;
}

.mb-30px {
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/cadastroRf/AppFormularioAvaliacaoImovel.vue